import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export const ScheduleIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(
  ({ ...props }, ref) => (
    <SvgIcon
      width="16"
      height="16"
      viewBox="0 0 64 64"
      fill="none"
      ref={ref}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.66 54.45H8.84A2.5 2.5 0 0 1 6.35 52V12.12a2.49 2.49 0 0 1 2.49-2.49h39.84a2.49 2.49 0 0 1 2.49 2.49v22.4M6.35 20.63h44.82M16.46 9.63v-5M40.42 9.63v-5"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
      />
      <circle
        cx="45.22"
        cy="45.44"
        r="12.43"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        d="M45.22 36.7v9.12l4.35 3.34"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
      />
    </SvgIcon>
  )
);
